import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

import { Audio, Playlist } from './models/audio';

@Directive({
  selector: 'cng-mediaplayer',
})
export class MediaplayerDirective extends UpgradeComponent {
  @Input() playlist: Playlist;
  @Input() currentAudio: Audio;
  @Output() currentAudioEvent: EventEmitter<Audio>;
  @Output() playingEvent: EventEmitter<boolean>;
  @Output() showEvent: EventEmitter<boolean>;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('cngMediaplayer', elementRef, injector);
  }
}
